module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.systemNotices.length > 0),
      expression: "systemNotices.length > 0"
    }],
    staticClass: "system-notice"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.systemNoticeSwitch1 != null) ? _c('p', {
    key: "systemNoticeSwitch1"
  }, [_vm._v(_vm._s(_vm.systemNoticeSwitch1.contentCn))]) : _vm._e(), _vm._v(" "), (_vm.systemNoticeSwitch2 != null) ? _c('p', {
    key: "systemNoticeSwitch2"
  }, [_vm._v(_vm._s(_vm.systemNoticeSwitch2.contentCn))]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    ref: "wrapper",
    staticClass: "scroll-content",
    style: ({
      height: _vm.contentH + 'px'
    })
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "auto-fill": false,
      "bottom-method": _vm.handleLoadMore,
      "bottom-all-loaded": _vm.allLoaded
    }
  }, [_c('div', _vm._l((_vm.messages), function(msg, index) {
    return _c('div', {
      key: index,
      staticClass: "field-block",
      on: {
        "click": function($event) {
          return _vm.handleViewClick(msg)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm._f("removeHtmlTag")(msg.msgContent)) + " "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.meetingId),
        expression: "msg.meetingId"
      }]
    }, [_vm._v("点击查看")])])
  }), 0)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-message-icon"
  }, [_c('i', {
    staticClass: "iconfont icon-xiaolaba"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-60b986d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b986d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/messages/list/index.vue
// module id = 760
// module chunks = 7